<template>
    <!-- DESCR：该页面负责发布会议 -->
    <div class="release-container">
        <!-- 页面信息描述 -->
        <el-row justify="center" @click="fast">
            <el-col :span="24" class="login-title">
                <div class="desc-box">
                    <div class="title">Create Conference</div>
                    <br />
                    <div class="info">
                        Creating a meeting is a unique feature of the chairman. You can post corresponding meetings on this
                        page, where information marked with an asterisk is mandatory. After the conference, the submitting
                        authors can submit their papers
                    </div>
                    <div class="info">
                        In addition, we will use Acronym to establish a conference paper submission website, so we must
                        ensure that Acronym is a unique and non repetitive abbreviation
                    </div>
                </div>
            </el-col>
        </el-row>
        <el-row :gutter="10">
            <el-col :span="24">
                <el-card class="box-card">
                    <el-form ref="ruleForm" :model="conferenceform" label-width="260px">
                        <el-form-item hide-required-asterisk prop="type"
                            :rules="[{ required: true, message: 'type Cannot be empty' }]">
                            <template #label>
                                <el-tooltip placement="top">
                                    <template #content>Installation type.<br />Specify the type of your
                                        installation</template>
                                    Type:
                                </el-tooltip>
                            </template>
                            <el-select v-model="conferenceform.type" placeholder="Please select a type">
                                <el-option value="conference" label="conference"></el-option>
                                <el-option value="book" label="book"></el-option>
                                <el-option value="used for teaching" label="used for teaching"></el-option>
                                <el-option value="journal special issue" label="journal special issue"></el-option>
                                <el-option value="journal" label="journal"></el-option>
                                <el-option value="conference proceedings" label="conference proceedings"></el-option>
                                <el-option
                                    value="processing applications for funding, positions, competitions, or any other proposals"
                                    label="processing applications for funding, positions, competitions, or any other proposals"></el-option>
                                <el-option value="other" label="other"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item prop="title" :rules="[{ required: true, message: 'title Cannot be empty' }]">
                            <template #label>
                                <el-tooltip placement="top">
                                    <template #content>
                                        Title and acronym.<br />
                                        Enter the conference's title <br />
                                        Title, acronym, and city should use English or any other language with the Latin
                                        alphabet, even if your conference uses <br />Chinese, Russian, Arabic etc. as the
                                        main
                                        language.</template>
                                    Conference title:
                                </el-tooltip>
                            </template>
                            <el-input v-model="conferenceform.title" style="width:700px"></el-input>
                        </el-form-item>
                        <el-form-item prop="acronym" :rules="[{ required: true, message: 'acronym Cannot be empty' },{ pattern: /^[a-zA-Z][a-zA-Z0-9 ]*$/, message: 'When it only contains English, spaces, and numbers, and must start with English' }]">
                            <template #label>
                                <el-tooltip placement="top">
                                    <template #content>Enter the conference acronym</template>
                                    Acronym:
                                </el-tooltip>
                            </template>
                            <el-input v-model="conferenceform.acronym" style="width:700px"></el-input>
                        </el-form-item>
                        <el-form-item prop="webpage" :rules="[{ required: true, message: 'webpage Cannot be empty' }]">
                            <template #label>
                                <el-tooltip placement="top">
                                    <template #content>
                                        Conference information.<br />Enter the conference Web page<br />If the conference
                                        has no
                                        Web
                                        page yet write 'none' in the corresponding field and add an explanation in 'Any
                                        other<br />information' below.</template>
                                    Web page:
                                </el-tooltip>
                            </template>
                            <el-input v-model="conferenceform.webpage" style="width:700px"></el-input>
                        </el-form-item>
                        <el-form-item prop="venue" :rules="[{ required: true, message: 'city Cannot be empty' }]">
                            <template #label>
                                <el-tooltip placement="top">
                                    <template #content>
                                        Enter the conference location.</template>
                                    Venue:
                                </el-tooltip>
                            </template>
                            <el-input v-model="conferenceform.venue" style="width:700px"></el-input>
                        </el-form-item>
                        <el-form-item prop="city" :rules="[{ required: true, message: 'Country Cannot be empty' }]">
                            <template #label>
                                <el-tooltip placement="top">
                                    <template #content>
                                        Enter the conference location.</template>
                                    City:
                                </el-tooltip>
                            </template>
                            <el-input v-model="conferenceform.city" style="width:700px"></el-input>
                        </el-form-item>
                        <el-form-item prop="country" :rules="[{ required: true, message: 'country Cannot be empty' }]">
                            <template #label>
                                <el-tooltip placement="top">
                                    <template #content>
                                        Enter the conference location.</template>
                                    Country/region:
                                </el-tooltip>
                            </template>
                            <el-select v-model="conferenceform.country" placeholder="Please select a country" filterable>
                                <el-option :value="item.label" :label="item.label" v-for="item in countryList"
                                    :key="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item prop="subnum" :rules="[{ required: true, message: 'submissions Cannot be empty' },{ pattern: /^[1-9]\d*$/, message: 'Can only be a positive integer' }]">
                            <template #label>
                                <el-tooltip placement="top">
                                    <template #content>
                                        If this is not the first time your conference is organized, you can base your
                                        estimation<br />
                                        on the number of submissions in previous years. Otherwise, enter your best
                                        guess.</template>
                                    Estimated number of submissions:
                                </el-tooltip>
                            </template>
                            <el-input v-model="conferenceform.subnum" style="width:700px"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <template #label>
                                <el-tooltip placement="top">
                                    <template #content>
                                        Dates.<br />
                                        Enter the conference dates click for more information.The dates must be in the
                                        format
                                        yyyy-mm-dd.
                                    </template>
                                    First day:
                                </el-tooltip>
                            </template>
                            <el-date-picker type="date" placeholder="Please select a date" v-model="conferenceform.firstday"
                                style="width: 600px" format="YYYY-MM-DD" value-format="YYYY-MM-DD"></el-date-picker>
                        </el-form-item>
                        <el-form-item prop="lastday" :rules="[{ required: true, message: 'lastday Cannot be empty' }]">
                            <template #label>
                                <el-tooltip placement="top">
                                    <template #content>
                                        Dates.<br />
                                        Enter the conference dates click for more information.The dates must be in the
                                        format
                                        yyyy-mm-dd.
                                    </template>
                                    Last day:
                                </el-tooltip>
                            </template>
                            <el-date-picker type="date" placeholder="Please select a date" v-model="conferenceform.lastday"
                                style="width: 600px" format="YYYY-MM-DD" value-format="YYYY-MM-DD"></el-date-picker>
                        </el-form-item>
                        <el-form-item>
                            <template #label>
                                <el-tooltip placement="top">
                                    <template #content>
                                        Research areas.<br />Select the main research area to which the conference belongs.
                                        If
                                        your conference fits into more than one area, choose the secondary area.</template>
                                    Primary area:
                                </el-tooltip>
                            </template>
                            <el-select v-model="conferenceform.primaryarea" placeholder="Please select a area">
                                <el-option :value="item.value" :label="item.label" v-for="item in areaList"
                                    :key="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <template #label>
                                <el-tooltip placement="top">
                                    <template #content>
                                        Research areas.<br />Select the main research area to which the conference belongs.
                                        If
                                        your conference fits into more than one area, choose the secondary area.</template>
                                    Secondary area:
                                </el-tooltip>
                            </template>
                            <el-select v-model="conferenceform.secondaryarea" placeholder="Please select a area">
                                <el-option :value="item.value" :label="item.label" v-for="item in areaList"
                                    :key="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <template #label>
                                <el-tooltip placement="top">
                                    <template #content>
                                        If your conference does not fit into our list of areas, please write some
                                        information
                                        about its research area to help us to improve our classification:</template>
                                    Area notes:
                                </el-tooltip>
                            </template>
                            <el-input type="textarea" :rows="2" v-model="conferenceform.areanotes"
                                style="width:700px"></el-input>
                        </el-form-item>
                        <el-form-item prop="organizer" :rules="[{ required: true, message: 'organizer Cannot be empty' }]">
                            <template #label>
                                <el-tooltip placement="top">
                                    <template #content>
                                        Organizer.<br />
                                        Enter information about the organizer<br />The Web page is mandatory if the
                                        organizer
                                        has a Web page.</template>
                                    Organizer:
                                </el-tooltip>
                            </template>
                            <el-input v-model="conferenceform.organizer" style="width:700px"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <template #label>
                                <el-tooltip placement="top">
                                    <template #content>
                                        Organizer.<br />
                                        Enter information about the organizer<br />The Web page is mandatory if the
                                        organizer
                                        has a Web page.</template>
                                    Organizer Web page
                                </el-tooltip>
                            </template>
                            <el-input v-model="conferenceform.organizerwebpage" style="width:700px"></el-input>
                        </el-form-item>
                        <el-form-item prop="contactphonenumber"
                            :rules="[{ required: true, message: 'contace phone number Cannot be empty' },{ pattern: /^1[3-9]\d{9}$/, message: 'Can only be a phone number' }]">
                            <template #label>
                                <el-tooltip placement="top">
                                    <template #content>
                                        The phone number should begin with + and include the country code.<br />
                                        Please note that we require a valid phone number where one of the organizers can be
                                        reached.</template>
                                    Contact phone number:
                                </el-tooltip>
                            </template>
                            <el-input v-model="conferenceform.contactphonenumber" style="width:700px"></el-input>
                        </el-form-item>
                        <el-form-item prop="role" :rules="[{ required: true, message: 'role Cannot be empty' }]">
                            <template #label>
                                <el-tooltip placement="top">
                                    <template #content>
                                        Other information.<br />
                                        Enter your role in the conference<br />If you are an author wanting to submit to a
                                        conference hosted by EasyChair, then this page is not for you: please check the
                                        submission page in the call for papers of the conference.</template>
                                    Your role:
                                </el-tooltip>
                            </template>
                            <el-input v-model="conferenceform.role" style="width:700px"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <template #label>
                                <el-tooltip placement="top">
                                    <template #content>
                                        You can enter any additional information that would help us to evaluate your
                                        request.
                                        This field is not mandatory<br />If you give additional information, please try to
                                        be
                                        concise and do not enter the call for papers or other information <br /> that we can
                                        find on
                                        your conference Web page. The maximum length of this field is 500
                                        characters.</template>
                                    Any other information:
                                </el-tooltip>
                            </template>
                            <el-input type="textarea" :rows="5" v-model="conferenceform.information"
                                style="width:700px"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-checkbox v-model="agree"
                                label="I confirm that I have read and understood ConfChair Meeting Policy"></el-checkbox>
                        </el-form-item>
                    </el-form>
                    <div class="submit"><el-button type="primary" :disabled="!agree" @click="submit">SendRequest</el-button>
                    </div>
                </el-card>
            </el-col>
        </el-row>
    </div>
</template>

<script setup>
import { ref } from "vue";
import { useRouter } from "vue-router";
import request from "../../network/request"
import { ElMessage } from 'element-plus'


//会议表单信息
const conferenceform = ref({
    type: '',
    title: '',
    acronym: '',
    webpage: '',
    venue: '',
    city: '',
    country: '',
    subnum: '',
    firstday: '',
    lastday: '',
    primaryarea: '',
    secondaryarea: '',
    areanotes: '',
    organizer: '',
    organizerwebpage: '',
    contactphonenumber: '',
    role: '',
    information: ''
})


const router = useRouter()
//国家列表信息（下拉列表）
const countryList = ref([])
//区域列表信息（下拉列表）
const areaList = ref([{ 'id': 1, 'value': 'Accounting and Finance', 'label': 'Accounting and Finance' }, { 'id': 2, 'value': 'Art and Humanities', 'label': 'Art and Humanities' }, { 'id': 3, 'value': 'Biological Sciences', 'label': 'Biological Sciences' }, { 'id': 4, 'value': 'Business and Management', 'label': 'Business and Management' }, { 'id': 5, 'value': 'Chemistry', 'label': 'Chemistry' }, { 'id': 6, 'value': 'Civil Engineering', 'label': 'Civil Engineering' }, { 'id': 7, 'value': 'Computing', 'label': 'Computing' }, { 'id': 8, 'value': 'Earth and Environmental Sciences', 'label': 'Earth and Environmental Sciences' }, { 'id': 9, 'value': 'Economics', 'label': 'Economics' }, { 'id': 10, 'value': 'Education Science', 'label': 'Education Science' }, { 'id': 11, 'value': 'Energy', 'label': 'Energy' }, { 'id': 12, 'value': 'Engineering', 'label': 'Engineering' }, { 'id': 13, 'value': 'Genomics and Bioinformatics', 'label': 'Genomics and Bioinformatics' }, { 'id': 14, 'value': 'Health Sciences', 'label': 'Health Sciences' }, { 'id': 15, 'value': 'Language and Linguistics', 'label': 'Language and Linguistics' }, { 'id': 16, 'value': 'Materials Science', 'label': 'Materials Science' }, { 'id': 17, 'value': 'Mathematics and Statistics', 'label': 'Mathematics and Statistics' }, { 'id': 18, 'value': 'Mechanical Engineering', 'label': 'Mechanical Engineering' }, { 'id': 19, 'value': 'Physics', 'label': 'Physics' }, { 'id': 20, 'value': 'Social Sciences', 'label': 'Social Sciences' }, { 'id': 21, 'value': 'Technology', 'label': 'Technology' }])
//是否同意发布表单协议
const agree = ref(false)
// 表单效验对象
const ruleForm = ref(null)

//从后端获取国家列表信息
request.get("/common/country").then((res) => {
    countryList.value = res.data
})

// 发布新会议
const submit = () => {
    // 效验表单信息
    ruleForm.value.validate((valid) => {
        if (valid) {
            request.post("/conference/release", conferenceform.value).then((res) => {
                if (res.code == 200) {
                    ElMessage.success({
                        message: 'created successfully',
                        type: 'success',
                    })
                    router.push("/common/myconferences")
                }
                else {
                    ElMessage.warning({
                        message: 'creation failed, acronym already exists',
                        type: 'warning',
                    })
                }
            })
        } else {
            return false
        }
    })
}
</script>

<style lang="scss">
.release-container {
    .login-title {
        background: #b7dffd3b;
        margin-bottom: 50px;
        padding: 20px 0;

        .desc-box {
            font-size: 16px;
            padding: 0 30px;

            .title {
                font-weight: 700;
                font-size: 20px;
                padding: 0;
                -webkit-background-clip: text;
                background-clip: text;
                background-image: linear-gradient(to right, rgb(28, 31, 32), rgb(3, 79, 129));
                color: transparent;
            }

            .info {
                padding: 0;
                font-size: 14px;
                margin-bottom: 10px;
            }
        }
    }

    .submit {
        width: 100%;
        padding: 0;
        display: flex;
        justify-content: center;

        .el-button {
            width: 300px;
        }
    }

    .box-card {
        display: flex;
        justify-content: center;
        position: relative;
        padding: 40px 0;
        margin-bottom: 30px;
        background-color: #eef8ff2e;
    }
}
</style>